import validator from 'validator';
const isEmpty = validator.isEmpty;

export function getPropertyByPath(object: any, propertyPath: any, defaultValue: any): any {
  let property, properties, reference;

  if (typeof propertyPath === 'number') {
    properties = [propertyPath];
  } else {
    properties = propertyPath.split('.');
  }

  reference = object;

  while (properties.length > 0) {
    property = properties.shift();

    if (reference && reference.hasOwnProperty(property)) {
      reference = reference[property];
    } else {
      return defaultValue;
    }

    if (properties.length === 0) {
      return reference;
    }
  }

  return typeof defaultValue === 'undefined' ? undefined : defaultValue;
}

export function replaceParams(text: string, params: any): string {
  if (typeof params !== 'object' || Object.keys(params).length === 0 || isEmpty(text)) {
    return text;
  }

  const variables = text.match(/:[a-z0-9_-]+/gi);

  let newText = text;
  if (variables !== null && variables.length) {
    for (const variable of variables) {
      const strippedVar = variable.substr(1);
      if (typeof params[strippedVar] !== 'undefined') {
        newText = newText.replace(variable, params[strippedVar]);
      }
    }
  }

  return newText;
}
